import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,
    state: {
        // backend_url: 'http://wb.uz/',
        backend_url: 'https://b-edo.maxam-chirchiq.uz/',
        access_token: Cookies.get('access_token') || "null",
        COMPANY_NAME_RU: "АО «MAXAM-CHIRCHIQ»",
        COMPANY_NAME_UZ_LATIN: "«MAXAM-CHIRCHIQ» AJ",
        COMPANY_NAME_UZ_CYRIL: "«MAXAM-CHIRCHIQ» АЖ",
        COMPANY_ID: 1,
        PHONE_IT: "3056, 3078",
        PHONE_PM: "3923",
        PHONE_PM_TASHKENT: "1729",
        user: null,
        permissions: null,
        roles: null,
        locale: Cookies.get('locale') || 'ru',
        errors: [],
        redirect_url: null,
        document_list: [],
        notifications: {}
    },
})
